import { CerListView } from '@slims/ui/organisms';
import { useAdminScopeTree } from '@/hooks/use-admin-scope';
import { useScopeTree } from '@/hooks/use-scope-tree';
import { useRouter } from '@/lib/next/navigation';
import { useAdminScopeStore } from '@/stores/admin-scope-store';
import { useAuthStore } from '@/stores/auth-store';
import SuperAdminDashboard from '@/pages/superadmin';

export default function CerPage() {
	const role = useAuthStore((s) => s.role);
	const availableOrgs = useAuthStore((s) => s.availableOrgs);
	const { tree, loading } = useScopeTree();
	const { tree: adminTree } = useAdminScopeTree();
	const router = useRouter();
	const setScope = useAdminScopeStore((s) => s.setScope);
	if (role === 'superadmin') return <SuperAdminDashboard />;
	const cers = tree.filter((cer) =>
		availableOrgs.some((org) => org.id === cer.id && org.role === 'admin'),
	);
	return (
		<CerListView
			cers={cers}
			loading={loading}
			onOpen={(id) => {
				const cer = cers.find((item) => item.id === id);
				if (!cer) return;
				setScope(id, adminTree.find((item) => item.id === id)?.configs[0]?.id ?? null);
				router.push(`/cer/orgs/${id}/details`);
			}}
		/>
	);
}
